import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Alert } from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import qs from 'qs';
import * as Sentry from '@sentry/react';
import { useTranslation } from 'react-i18next';
import md5 from 'md5';
import i18n from '../../utils/i18n';
import { storeTokenData, getTokenData } from '../../utils/helpers';
import client from '../../utils/client';
import { Store } from '../../Store';

const Login = () => {
  const { t } = useTranslation();

  const { dispatch } = useContext(Store);
  const navigate = useNavigate();
  const location = useLocation();

  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    (async () => {
      // Fix for indexed login urls.
      const { referrer } = document;
      if (referrer.includes('google')) {
        setErrorMessage('Invalid link from google');
        return;
      }

      const params = qs.parse(location.search, {
        ignoreQueryPrefix: true
      });

      let qString = `?login=1&id=${params.id}&date=${Date.now()}&hash=${params.hash}`;
      if (params.sa) {
        qString += `&sa=1&sa-hash=${md5(params.id + params.id)}`;
      }

      const { data, error } = await client(`admin-gc/login${qString}`);

      if (error) {
        setErrorMessage(true);
      } else {
        storeTokenData(data.token);

        const tokenData = getTokenData();
        Sentry.setUser({ id: tokenData.gId, golfclub: tokenData.name });

        const language = (tokenData.language === 'no' ? 'nb' : tokenData.language) || 'en';
        // console.log('language', language);

        i18n.changeLanguage(language);

        try {
          const { data: checkinResponse } = await client(
            `admin-gc/checkin`,
            { body: { language } },
            'POST'
          );
          dispatch({
            type: 'RESTRICTIONS_FETCHED',
            payload: { days: checkinResponse.days, weekRest: checkinResponse.weekRest }
          });
          dispatch({
            type: 'ADMIN_CONTACT_FETCHED',
            payload: {
              name: checkinResponse.contactName,
              email: checkinResponse.contactEmail,
              phone: checkinResponse.contactPhone
            }
          });
        } catch {}

        navigate(`/golfclub-admin/${params.redirect ? params.redirect : 'dashboard'}`);
      }
    })();
  }, []);

  return (
    <>
      <div
        className="header py-7 py-lg-8 pt-lg-9"
        style={{ height: '100vh', background: '#2dce89' }}
      >
        <Container>
          <div className="mb-7">
            <Row className="justify-content-center">
              <Col
                className="px-5"
                lg="6"
                md="8"
                xl="5"
                style={{ alignItems: 'center', display: 'flex', flex: 1, flexDirection: 'column' }}
              >
                <h1 className="text-white">{t('login.welcome', 'Välkommen')}</h1>
                <p className="text-lead text-white">
                  {t('login.welcome-wait', 'Vänligen vänta medan vi loggar in er...')}
                </p>
                {!errorMessage ? (
                  <div className="reverse-spinner" />
                ) : (
                  <Alert color="danger">
                    {t('login.wrong-link', 'Felaktig länk, vänligen kontakta Golfamore')}
                  </Alert>
                )}
              </Col>
            </Row>
          </div>
        </Container>
        <div className="separator separator-bottom separator-skew zindex-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon className="fill-default" points="2560 0 2560 100 0 100" />
          </svg>
        </div>
      </div>
    </>
  );
};

export default Login;
